import React from 'react'
import { Switch, Route } from 'react-router-dom'
import Index from './Index'

export default () => (
  <Switch>
    {/* <Route exact path='/camera-status-dashboard' component={Index} /> */}
  </Switch>
)
